// extracted by mini-css-extract-plugin
export default {"card":"Card_card__8bova","image":"Card_image__9czXL","caption":"Card_caption__IvIm6","left_line":"Card_left_line__98BOf","description":"Card_description__WaSam"};